import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';

const messages = defineMessages({
  TIME_LIMIT_WARNING: {
    id: 'CallTimer.TIME_LIMIT_WARNING',
    defaultMessage: 'Zeitlimit fast erreicht',
  },
  TIME_LIMIT_TEXT: {
    id: 'CallTimer.TIME_LIMIT_TEXT',
    defaultMessage: 'Der Video-Call nähert sich dem 60-Minuten-Limit und wird in wenigen Sekunden automatisch beendet.',
  },
  EXTEND_CALL: {
    id: 'CallTimer.EXTEND_CALL',
    defaultMessage: 'Gespräch verlängern',
  },
  EXTENSIONS_LEFT: {
    id: 'CallTimer.EXTENSIONS_LEFT',
    defaultMessage: 'Verlängerungen übrig:',
  },
  CURRENT_DURATION: {
    id: 'CallTimer.CURRENT_DURATION',
    defaultMessage: 'Aktuelle Dauer:',
  },
  PLUS_5_MIN: {
    id: 'CallTimer.PLUS_5_MIN',
    defaultMessage: '(+5 Min)',
  },
});

class CallTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elapsedSeconds: 0,
      extensionsUsed: 0,
      showWarningModal: false,
    };
    this.interval = null;
    this.maxExtensions = 2;
    this.baseLimitSeconds = 3600; // 60 minutes
    this.extensionSeconds = 300; // 5 minutes
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  componentDidUpdate(prevProps) {
    // If call begin changes, or remote connects, re-evaluate
    if (this.props.callBeginDate !== prevProps.callBeginDate || this.props.remoteConnected !== prevProps.remoteConnected) {
      if (this.props.remoteConnected && this.props.callBeginDate) {
        if (!this.interval) this.startTimer();
      }
    }
  }

  startTimer = () => {
    this.stopTimer();
    this.interval = setInterval(this.tick, 1000);
    this.tick();
  };

  stopTimer = () => {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  };

  tick = () => {
    const { callBeginDate, remoteConnected, onDisconnect } = this.props;
    if (!remoteConnected || !callBeginDate) return;

    const now = new Date();
    const begin = new Date(callBeginDate);
    const elapsedSeconds = Math.floor((now.getTime() - begin.getTime()) / 1000);

    const currentLimit = this.baseLimitSeconds + (this.state.extensionsUsed * this.extensionSeconds);
    const warningThreshold = currentLimit - 60; // Show warning 60 seconds before disconnect

    this.setState({ elapsedSeconds });

    if (elapsedSeconds >= currentLimit) {
      // Hard disconnect!
      this.stopTimer();
      this.setState({ showWarningModal: false });
      if (onDisconnect) {
        onDisconnect();
      }
    } else if (elapsedSeconds >= warningThreshold && !this.state.showWarningModal && this.state.extensionsUsed < this.maxExtensions) {
      // Show warning modal
      this.setState({ showWarningModal: true });
    }
  };

  handleExtend = () => {
    if (this.state.extensionsUsed < this.maxExtensions) {
      this.setState(prevState => ({
        extensionsUsed: prevState.extensionsUsed + 1,
        showWarningModal: false,
      }));
    }
  };

  formatTime(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }

  render() {
    const { intl: { formatMessage } } = this.props;
    const { elapsedSeconds, showWarningModal, extensionsUsed } = this.state;
    
    // Only render the modal if it's active
    if (!showWarningModal) return null;

    return (
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          backgroundColor: 'var(--panel-bg)',
          borderRadius: '12px',
          padding: '32px',
          maxWidth: '400px',
          textAlign: 'center',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.2)',
          border: '1px solid var(--panel-border)',
          color: 'var(--text-color)'
        }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', backgroundColor: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '28px' }}>
            <i className="fa fa-clock-o"></i>
          </div>
          <h2 style={{ margin: '0 0 16px 0', fontSize: '22px', fontWeight: 'bold' }}>
            {formatMessage(messages.TIME_LIMIT_WARNING)}
          </h2>
          <p style={{ margin: '0 0 24px 0', fontSize: '15px', lineHeight: '1.5', color: 'var(--text-muted)' }}>
            {formatMessage(messages.TIME_LIMIT_TEXT)}<br/><br/>
            {formatMessage(messages.CURRENT_DURATION)} {this.formatTime(elapsedSeconds)}
          </p>
          
          <button 
            onClick={this.handleExtend}
            className="lh-btn lh-btn-primary lh-btn-block"
            style={{ padding: '12px', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px' }}
          >
            {formatMessage(messages.EXTEND_CALL)} {formatMessage(messages.PLUS_5_MIN)}
          </button>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
            {formatMessage(messages.EXTENSIONS_LEFT)} {this.maxExtensions - extensionsUsed} / {this.maxExtensions}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(CallTimer);
